import React from 'react';
import ONCRP_TOOLS_QP_Card from './OncoRiskCard';
import { KeyValue } from './CommonComponents';

const TranscriptConsequencesCard = ({ vepData }) => {
    if (!vepData) return null;

    return (
        <ONCRP_TOOLS_QP_Card title="Transcript Consequences" icon="fa-file-code" className="ONCRP-TOOLS-QP-span-col-6">
            <KeyValue label="Most Severe Consequence">{vepData.most_severe_consequence?.replace(/_/g, ' ')}</KeyValue>
            {vepData.transcript_consequences?.map((tc, i) => (
                <div key={i} className="ONCRP-TOOLS-QP-section">
                    <h4>Transcript: {tc.transcript_id} {tc.canonical ? <span className="ONCRP-TOOLS-QP-tag ONCRP-TOOLS-QP-tag-sig">Canonical</span> : ''}</h4>
                    <div className="ONCRP-TOOLS-QP-kv-grid two-column-grid">
                        <KeyValue label="Gene">{`${tc.gene_symbol} (${tc.gene_symbol_source}) / ID: ${tc.gene_id}`}</KeyValue>
                        <KeyValue label="Impact">{tc.impact}</KeyValue>
                        <KeyValue label="HGVS (gDNA)">{tc.hgvsg}</KeyValue>
                        <KeyValue label="HGVS (cDNA)">{tc.hgvsc}</KeyValue>
                        <KeyValue label="HGVS (Protein)">{tc.hgvsp}</KeyValue>
                        <KeyValue label="Consequence Terms">{tc.consequence_terms.join(', ').replace(/_/g, ' ')}</KeyValue>
                        <KeyValue label="Position (Protein)">{tc.protein_start}-{tc.protein_end}</KeyValue>
                        <KeyValue label="Position (CDS)">{tc.cds_start}-{tc.cds_end}</KeyValue>
                        <KeyValue label="Amino Acids / Codons">{`${tc.amino_acids} / ${tc.codons}`}</KeyValue>
                        <KeyValue label="Variant Allele">{tc.variant_allele}</KeyValue>
                    </div>
                    {tc.spliceai && <div className="ONCRP-TOOLS-QP-section">
                        <h5>SpliceAI Scores</h5>
                        <div className="ONCRP-TOOLS-QP-kv-grid four-column-grid">
                            <KeyValue label="Symbol">{tc.spliceai.SYMBOL}</KeyValue>
                            <KeyValue label="Acceptor Gain">{`${tc.spliceai.DS_AG} at ${tc.spliceai.DP_AG}`}</KeyValue>
                            <KeyValue label="Acceptor Loss">{`${tc.spliceai.DS_AL} at ${tc.spliceai.DP_AL}`}</KeyValue>
                            <KeyValue label="Donor Gain">{`${tc.spliceai.DS_DG} at ${tc.spliceai.DP_DG}`}</KeyValue>
                            <KeyValue label="Donor Loss">{`${tc.spliceai.DS_DL} at ${tc.spliceai.DP_DL}`}</KeyValue>
                        </div>
                    </div>}
                </div>
            ))}
        </ONCRP_TOOLS_QP_Card>
    );
};

export default TranscriptConsequencesCard; 